export default __webpack_public_path__ + "static/media/5.8ab9cd7e.jpg";